import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]

import { computed, reactive, ref, unref, inject } from 'vue'
import { injectKey, Nicotto, ConciergeDepartment, ConciergeProcess } from '@/plugins/nicotto'
import { useValidateForm } from '@/components/ui/validator'
import FormGroup from '@/components/ui/FormGroup.vue'
import InputText from '@/components/ui/InputText.vue'
import InputSelect from "@/components/ui/InputSelect.vue";
import InputLinks from "@/components/ui/InputLinks.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ConciergeProcess',
  props: {
    modelValue: null
  },
  emits: ["update:modelValue", "submit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'update:modelValue', process: ConciergeProcess): void,
  (event: 'submit'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: ConciergeProcess
}



// eslint-disable-next-line func-call-spacing


const keys = ['processId', 'name', 'department']
const process = reactive<any>({})
keys.forEach(key => {
  process[key] = computed({
    get() {
      return props.modelValue[key as keyof ConciergeProcess]
    },
    set(val) {
      emit('update:modelValue', new ConciergeProcess({ ...props.modelValue, [key]: val}))
    }
  })
})

process.links = computed({
  get() {
    return [ props.modelValue.link ]
  },
  set(val) {
    emit('update:modelValue', new ConciergeProcess({ ...props.modelValue, link: val[0] }))
  }
})

const form = ref<HTMLFormElement|null>(null)
const submit = () => {
  if (! useValidateForm(unref(form) as unknown as HTMLFormElement).isValid()) {
    return
  }
  emit('submit')
}

const departments = ref<ConciergeDepartment[]>([])
const nicotto = inject(injectKey) as Nicotto
nicotto.concierge.getDepartmentList()
  .then(data => {
    departments.value = data
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"]),
    ref_key: "form",
    ref: form,
    class: "formTable",
    novalidate: ""
  }, [
    _createVNode(FormGroup, {
      label: "手続き名",
      required: true,
      "label-for": "name"
    }, {
      default: _withCtx(() => [
        _createVNode(InputText, {
          label: "手続き名",
          required: true,
          id: "name",
          modelValue: process.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((process.name) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createVNode(FormGroup, {
      label: "担当課",
      required: true,
      "label-for": "department"
    }, {
      default: _withCtx(() => [
        _createVNode(InputSelect, {
          label: "担当課",
          id: "department",
          required: true,
          modelValue: process.department,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((process.department) = $event)),
          options: departments.value
        }, null, 8, ["modelValue", "options"])
      ]),
      _: 1
    }),
    _createVNode(FormGroup, { label: "関連リンク" }, {
      default: _withCtx(() => [
        _createVNode(InputLinks, {
          modelValue: process.links,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((process.links) = $event)),
          "min-length": 1,
          "max-length": 1
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _renderSlot(_ctx.$slots, "default")
  ], 40, _hoisted_1))
}
}

})